import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import { getInitPopUpData } from "@shared/utils/CommonUtils";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SCT_POR_REG_001_POP_001 = forwardRef(
  ({ selectedData }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });

    useImperativeHandle(ref, () => ({
      getOkayData: () => {
        return {
          rtnData: [
            gridRefs.current["grid1"].current?.getCheckedRows() || [],
            gridRefs.current["grid2"].current?.getCheckedRows() || [],
          ],
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_SCT_POR_REG_001_POP_001",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
          // gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_sct_por_reg_001_pop_01_01",
          params: searchRef.current.getFormdata(),
        };
        const data: any = await fnGetDataSet(param);

        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
        });

        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
      } catch (error: any) {}
    };

    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const no_prq = selectedRow.no_prq;
        gridRefs.current["grid2"].current.applyFilters({ no_prq: no_prq });
      } else {
        return;
      }
    };

    const onCheckedRowChaged1 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid2"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid2"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChaged2 = (value: boolean) => {
      const checkdRows =
        gridRefs.current["grid2"].current.getCheckedFilteredRows();
      if (checkdRows.length > 0)
        gridRefs.current["grid1"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid1"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged,
            onCheckedRowChaged: onCheckedRowChaged1,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChaged2,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 h-full min-h-0 space-y-1.5">
          <div style={{ height: "25vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                rowSelection: "multiple",
                ischeckboxSelection: true,
              }}
              events={grids.grid1.events}
            />
          </div>
          <div style={{ height: "25vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid2"]}
              columnConfig={grids.grid2.columns}
              rowData={grids.grid2.dataSource}
              etcProps={{
                rowSelection: "multiple",
                ischeckboxSelection: true,
              }}
              events={grids.grid2.events}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_SCT_POR_REG_001_POP_001;
